import { cn } from '@repo/ui/lib/utils'
import { ComponentPropsWithoutRef, FunctionComponent } from 'react'

const Skeleton: FunctionComponent<ComponentPropsWithoutRef<'div'>> = ({ className, ...props }) => {
  return (
    <div className={cn('bg-(--color-foreground)/3 animate-pulse rounded-lg', className)} role='status' aria-live='polite' aria-busy='true' {...props}>
      <span className='sr-only'>Loading...</span>
    </div>
  )
}

export { Skeleton }
